import { useAuth } from "../context/AuthContext";
import "./WatermarkOverlay.css";

/**
 * Viewer-identifying corner watermark for unlocked drop media.
 * Uses the logged-in viewer's username (deterrent), gated by the creator's
 * watermark setting (userSettings.contentWatermarking / watermarkEnabled).
 */
export default function WatermarkOverlay({ creator, visible = true }) {
  const { currentUser, userProfile } = useAuth();

  if (!visible || !currentUser) return null;

  const watermarkOn =
    creator?.userSettings?.contentWatermarking
    ?? creator?.watermarkEnabled
    ?? true;
  if (!watermarkOn) return null;

  const username =
    userProfile?.username
    || userProfile?.handle
    || currentUser?.displayName
    || "";
  const handle = String(username).replace(/^@/, "").trim();
  if (!handle) return null;

  return (
    <div className="dv-watermark" aria-hidden="true">
      Viewed by @{handle}
    </div>
  );
}
